function cleanBuildValue(value: string | undefined): string | undefined {
  const clean = value?.trim();
  if (!clean) return undefined;
  if (/^\$[A-Z0-9_]+$/.test(clean)) return undefined;
  return clean;
}

// import.meta.env is a Vite-only feature: real dev/build/preview runs always
// have it, but node:test's --experimental-strip-types runner (no Vite
// transform at all) does not, and would throw reading .VITE_APP_VERSION off
// undefined. The optional chain only matters in that second context - this
// module is the one lib/sentry.ts pulls in for SENTRY_RELEASE, and sentry.ts
// needs to import cleanly under plain node so its setSentryUser/clearSentryUser
// contract test can run the real module rather than a reimplementation.
export const BUILD_VERSION =
  cleanBuildValue(import.meta.env?.VITE_APP_VERSION as string | undefined) ?? 'dev';

export const BUILD_VERSION_LABEL =
  BUILD_VERSION.length > 12 ? BUILD_VERSION.slice(0, 8) : BUILD_VERSION;

export const SENTRY_RELEASE = BUILD_VERSION === 'dev' ? undefined : BUILD_VERSION;